import React, { useState } from 'react';
import './index.css';
import CalendarGrid from '../calendar-grid';
import EmptyState from '../empty-state';
import LoadingState from '../loading-state';

function ExpandedSchedule({ scheduledPosts, fullyLoaded }) {
    const [monthToDisplay, SetMonthToDisplay] = useState(new Date());

    const moveToNextMonth = () => {
        const currentMonth = monthToDisplay;
        const newMonthToDisplay = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1);
        SetMonthToDisplay(newMonthToDisplay);
    };

    const moveBackAMonth = () => {
        const currentMonth = monthToDisplay;
        const newMonthToDisplay = new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1);
        SetMonthToDisplay(newMonthToDisplay);
    };

    // Early return for loading state
    if (!fullyLoaded) {
        return <LoadingState />;
    }

    return (
        <>
            {scheduledPosts && scheduledPosts.length > 0 ? (
                <>
                    <div className='controller-expanded-schedule'>
                        <h2 className='date-displayed medium-text'>
                            {monthToDisplay.toLocaleString('default', { month: 'long' })} {monthToDisplay.getFullYear()}
                        </h2>
                        <div>
                            <img onClick={moveBackAMonth} className="idea-schedule-icon month-skip" id='back-month' src="./images/next.png" alt="Back" />
                            <img onClick={moveToNextMonth} className="idea-schedule-icon month-skip" id='forward-month' src="./images/next.png" alt="Forward" />
                        </div>
                    </div>
                    <CalendarGrid time={monthToDisplay} expandedBool={true} posts={scheduledPosts} />
                </>
            ) : (
                <EmptyState message="No scheduled ideas yet." />
            )}
        </>
    );
}

export default ExpandedSchedule;
